export default __webpack_public_path__ + "static/media/BenjaminGonzalez.589b946e.png";